import Icons from 'components/Icons';
import Separator from 'components/Separator';
import './inquiryForm.scss'
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { checkImageUrl, inputChange } from 'utils/modules/Handlers';
import actions from 'store/actions';
import { toast } from 'react-toastify';
import NoUser from 'assets/images/no_user.jpg'
import moment from 'moment';
import CustomTextInput from 'components/CustomTextInput';
import CustomButton from 'components/CustomButton';

const InquiryForm = ({ data, popup }) => {
    const initialForm = {
        first_name: {
            value: '',
            error: '',
        },
        last_name: {
            value: '',
            error: '',
        },
        email: {
            value: '',
            error: '',
        },
        message: {
            value: '',
            error: '',
        },
        phone_number: {
            value: '',
        },
        date: {
            value: '',
        },
        time: {
            value: '',
        },
    }
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const [type, setType] = useState('general')
    const [form, setForm] = useState(initialForm);
    const [loading, setLoading] = useState(false);
    const [profile, setProfile] = useState({})

    useEffect(() => {
        const init = async() => {
            if (user.id && (user.user_type === 'buyer' || user.user_type === 'seller')) {
                const data = await dispatch(actions.buyer.fetchBuyerProfile());
                if (data.length > 0) {
                    setProfile(data[0]);
                }
            }
        }

        init();
    }, [])

    const onChangeInput = ({ event, type }) => {
        const data = event.target.value;
        inputChange({ setForm: setForm, key: type, value: 'value', data: data })
    }

    const validateEmail = (email) => {
        return email.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };

    const validatePhone = (phone_number) => {
        let phone = `+1${phone_number}`
        return phone.match(/(^\+\d{11}(\d{2})?$)/);
    };

    const clearInput = () => {
        setForm(initialForm);

        let first_name = document.getElementById('first_name')
        if (first_name) { first_name.value = '' }

        let last_name = document.getElementById('last_name')
        if (last_name) { last_name.value = '' }

        let email = document.getElementById('email')
        if (email) { email.value = '' }

        let phone_number = document.getElementById('phone_number')
        if (phone_number) { phone_number.value = '' }

        let date = document.getElementById('date')
        if (date) { date.value = '' }

        let time = document.getElementById('time')
        if (time) { time.value = '' }

        let message = document.getElementById('message')
        if (message) { message.value = '' }

    }

    const onSubmit = useCallback(async () => {
        const { email, first_name, last_name, phone_number, message, date, time } = form
        let isValid = true
        if (!user.id) {
            if (first_name.value === '') {
                inputChange({ setForm: setForm, key: 'first_name', value: 'error', data: 'First name cannot be blank' })
                isValid = false
            } else {
                inputChange({ setForm: setForm, key: 'first_name', value: 'error', data: '' })
            }

            if (last_name.value === '') {
                inputChange({ setForm: setForm, key: 'last_name', value: 'error', data: 'Last name cannot be blank' })
                isValid = false
            } else {
                inputChange({ setForm: setForm, key: 'last_name', value: 'error', data: '' })
            }

            if (!validateEmail(email.value)) {
                inputChange({ setForm: setForm, key: 'email', value: 'error', data: 'Entered email address is invalid' })
                isValid = false
            } else {
                inputChange({ setForm: setForm, key: 'email', value: 'error', data: '' })
            }
            if (phone_number.value) {
                if (!validatePhone(phone_number.value)) {
                    inputChange({ setForm: setForm, key: 'phone_number', value: 'error', data: 'Please enter the right 10-digit phone number' })
                    isValid = false
                } else {
                    inputChange({ setForm: setForm, key: 'phone_number', value: 'error', data: '' })
                    isValid = true
                }
            }
        }

        if (message.value === '') {
            inputChange({ setForm: setForm, key: 'message', value: 'error', data: 'Message cannot be blank' })
            isValid = false
        } else {
            inputChange({ setForm: setForm, key: 'message', value: 'error', data: '' })
            isValid = true
        }

        if (type === 'showing') {
            if (date.value === '') {
                inputChange({ setForm: setForm, key: 'date', value: 'error', data: 'Date cannot be blank' })
                isValid = false
            } else {
                inputChange({ setForm: setForm, key: 'date', value: 'error', data: '' })
                isValid = true
            }
            if (time.value === '') {
                inputChange({ setForm: setForm, key: 'time', value: 'error', data: 'Time cannot be blank' })
                isValid = false
            } else {
                inputChange({ setForm: setForm, key: 'time', value: 'error', data: '' })
                isValid = true
            }
        }

        if (isValid) {
            setLoading(true);
            try {
                let dataForm = {
                    inquiry_type: type,
                    message: message.value,
                };

                if (user.id) {
                    dataForm.first_name = user.first_name;
                    dataForm.last_name = user.last_name;
                    dataForm.email = user.email;
                    dataForm.phone_number = user.phone_number ? `+1${user.phone_number}` : '';
                    dataForm.listing = data.id;
                    dataForm.inquirer = user.id;
                } else {
                    dataForm.first_name = first_name.value;
                    dataForm.last_name = last_name.value;
                    dataForm.email = email.value;
                    dataForm.phone_number = phone_number.value ? `+1${phone_number.value}` : '';
                    dataForm.listing = data.id;
                }


                if (type === 'showing') {
                    dataForm.showing_date = `${moment(date.value, 'YYYY-MM-DD').format('YYYY-MM-DD').toString()}T${moment(time.value, 'HH:mm').format('HH:mm:ss').toString()}`;
                }
                await dispatch(actions.buyer.postBuyerInquiry(dataForm)).then(() => {
                    toast.success('Message Sent!', {
                        position: toast.POSITION.TOP_CENTER
                    });
                    setLoading(false);
                });

            } catch (error) {
                toast.error('Something went wrong!', {
                    position: toast.POSITION.TOP_CENTER
                });
                setLoading(false);
            }
            clearInput();
        }
    }, [form, type, data, user])

    const onDirectMessage = (event) => {
        event.preventDefault();
        popup.show()
    }

    return (
        <>
            {
                data.id &&
                <div className='inquiry-form-container'>
                    <div className='listing-agent'>
                        <div>
                            <img src={checkImageUrl(data.agent_data?.profile_photo, NoUser)} alt='' />
                            <div className='details'>
                                <div className='name'>
                                    <p>{data.agent_data?.full_name}</p>
                                    <Icons.ListingAgentBadge width={8} height={8} />
                                </div>
                                <p className='company'>{data.agent_data?.company_name || 'Independent'}</p>
                            </div>
                        </div>
                        <div className='verified-agent'>
                            <Icons.ListingAgentBadge width={20} height={20} />
                            <div>
                                <p>Verified Listing Agent</p>
                                <span>Deal with confidence</span>
                            </div>
                        </div>
                        {
                            user.id && user.user_type === 'agent' &&
                            <CustomButton 
                                size={'small'}
                                text={'Message'}
                                action={(event) => onDirectMessage(event)}
                                type='secondary'
                            />
                        }
                    </div>
                    <Separator height={24} />
                    <p style={{ fontSize: 14, fontWeight: 600, color: '#5F5F5F', margin: 0 }}>Inquire with an agent</p>
                    <Separator height={8} />
                    <div className='inquiry-type'>
                        <div className={`${type === 'general' && 'active'}`} onClick={() => setType('general')}>General Inquiry</div>
                        <div className={`${type === 'listing' && 'active'}`} onClick={() => setType('listing')}>Listing Inquiry</div>
                        <div className={`${type === 'showing' && 'active'}`} onClick={() => setType('showing')}>Showing Inquiry</div>
                    </div>
                    {
                        !user.id &&
                        <>
                            <Separator height={16} />
                            <div className='form'>
                                <CustomTextInput
                                    label={'First Name'}
                                    inputProps={{
                                        type: "text",
                                        placeholder: 'John',
                                        id: 'first_name',
                                        onChange: (event) => onChangeInput({ event, type: "first_name" })
                                    }}
                                    error={form.first_name.error}
                                />
                                <CustomTextInput
                                    label={'First Name'}
                                    inputProps={{
                                        type: "text",
                                        placeholder: 'Doe',
                                        id: 'last_name',
                                        onChange: (event) => onChangeInput({ event, type: "last_name" })
                                    }}
                                    error={form.last_name.error}
                                />
                            </div>
                            <Separator height={16} />
                            <div className='form'>
                                <CustomTextInput
                                    label={'Email Address'}
                                    inputProps={{
                                        type: "email",
                                        placeholder: 'example@email.com',
                                        id: 'email',
                                        autoComplete: "off",
                                        onChange: (event) => onChangeInput({ event, type: "email" })
                                    }}
                                    error={form.email.error}
                                />
                                <CustomTextInput
                                    label={'Phone Number (Optional)'}
                                    inputProps={{
                                        type: "tel",
                                        placeholder: '',
                                        id: 'phone_number',
                                        maxLength: 10,
                                        onChange: (event) => onChangeInput({ event, type: "phone_number" })
                                    }}
                                />
                            </div>
                        </>
                    }
                    {
                        type === 'showing' &&
                        <>
                            <Separator height={16} />
                            <div className='form'>
                        
                            <CustomTextInput
                                    label={'Date'}
                                    inputProps={{
                                        type: "date",
                                        id: 'date',
                                        min: moment().format('YYYY-MM-DD').toString(),
                                        onChange: (event) => onChangeInput({ event, type: "date" })
                                    }}
                                    error={form.date.error}
                                />
                                <CustomTextInput
                                    label={'Time'}
                                    inputProps={{
                                        type: "time",
                                        id: 'time',
                                        onChange: (event) => onChangeInput({ event, type: "time" })
                                    }}
                                    error={form.time.error}
                                />
                            </div>
                        </>
                    }
                    <Separator height={16} />
                    <CustomTextInput
                        label={'Message'}
                        inputProps={{
                            type: "text",
                            placeholder: 'Ask us about the listing',
                            id: 'message',
                            style: { width: '100%' },
                            onChange: (event) => onChangeInput({ event, type: "message" })
                        }}
                        error={form.message.error}
                    />
                    <CustomButton
                        text='Submit'
                        iconOnly={loading ? <Icons.Loading height={40} width={40} background={'none'} /> : false}
                        action={onSubmit}
                    />
                    {
                        ((user.user_type === 'buyer' || user.user_type === 'seller') && profile.default_buyer_agent) &&
                        <div className='buyer-agent'>
                            <div>
                                <img src={checkImageUrl(profile.default_buyer_agent?.profile_photo, NoUser)} alt='' />
                                <div className='details'>
                                    <div className='name'>
                                    <p>{profile.default_buyer_agent?.first_name} {profile.default_buyer_agent?.last_name}</p>
                                        <Icons.BuyerAgentBadge width={8} height={8} />
                                    </div>
                                    <p className='company'>{profile.default_buyer_agent?.email}</p>
                                </div>
                            </div>
                            <p> You currently have a Buyer’s Agent</p>
                        </div>
                    }
                </div>
            }
        </>
    )
}


export default InquiryForm;